/**
 * Instagram Feed Slider.
 * 
 */

/**
 * Desktop: 5-across slider.
 * Mobile: 2-across slider.
 */

/* global jQuery */

const $ = jQuery;   // jQuery loaded via WordPress enqueue process

function initInstaSlider() {
    // Set up slider for SmashBalloon Instagram images in mobile.
	// console.log('initInstaSlider()');

    let 
        $mySlider = $('#sbi_images'),
        options = {
            centerMode:false,
            cssEase:'ease-out',
            infinite:false,
            mobileFirst:true,
            slidesToShow:2,
            // slidesToScroll:2,
            swipe:true,
            swipeToSlide:true,
            arrows:true,
            adaptiveHeight:true,
            // prevArrow: $('.irl__arrow.prev'),
            // nextArrow: $('.irl__arrow.next'),
            responsive: [
                {
                    breakpoint:510,
                    // breakpoint:480,
                    settings: {
                        slidesToShow:2,
                        // slidesToScroll:2,
                    }
                },
                {
                    breakpoint:768,
                    // breakpoint:800,
                    settings: {
                        slidesToShow:3,
                        // slidesToScroll:3,
                    }
                },
                {
                    breakpoint:1024,
                    // breakpoint:800,
                    settings: {
                        arrows:false,
                        slidesToShow:4,
                        // slidesToScroll:4,
                    }
                },
                {
                    breakpoint:1200,
                    // breakpoint:800,
                    settings: {
                        arrows:false,
                        slidesToShow:5,
                    }
                }
            ]
        };

    $mySlider.slick(options);
}

function restoreSlickSlideImages() {
    // console.log('restoreSlickSlideImages()');

    let 
        $dupes = $('.sbi_num_diff_hide');

    $dupes.each(function(i) {
        var $postAnchor = $(this).find('a.sbi_photo');
        var $postImg = $(this).find('img');
        var image_url = $postAnchor.data('full-res');
        image_url = image_url.replace("full", "low");
        $postAnchor.css('background-image', 'url('+image_url+')');
        $(this).removeClass('sbi_num_diff_hide');
        $postImg.attr('src', image_url);
    });
}

exports.init = function() {
    // console.log('INSTAGRAM: exports.init');
	// Run init methods...

    initInstaSlider();
    // setTimeout(restoreSlickSlideImages, 1000);
};

function initModule(mod) {
	// console.log("initModule(): "+mod);
    if ((mod !== null) && (typeof mod !== 'undefined') && (typeof mod.init === 'function')) {
        mod.init();
    }
}